import jQuery from "jquery";

jQuery(document).ready(function ($) {

    function setQueryStringParameter(name, value) {
        const params = new URLSearchParams(window.location.search);
        params.set(name, value);
        window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
    }

    function deleteQueryStringParameter(name) {
        const params = new URLSearchParams(window.location.search);
        params.delete(name);
        window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
    }

    function prepareParamsForUrl() {
        var filters = parseFilters();
        var tags = parseTags();
        var sort = parseSort();
        var taxonomies = parseTaxonomies();

        setQueryStringParameter('tags', tags);
        setQueryStringParameter('order', sort);
        setQueryStringParameter('type', filters);

        if (taxonomies && taxonomies.length > 0) {
            setQueryStringParameter('terms', taxonomies);
        }
    }

    jQuery(document).on('click', '.tag-search-form li', function (e) {

        if(isAllTagsAreSelected() || checkIsNewRow($(this).parent()))
            deactivateAllTags();

        jQuery(this).toggleClass('active');
        const tags = parseTags();
        jQuery(this).closest('.tag-search-form').parent().find('.tags_search').val(tags);
        checkTags();

        submitForm();
    });

    jQuery(document).on('change', '.sorting-select', function (e) {

        var filters = parseFilters();
        var tags = parseTags();
        var sort = parseSort();
        var perPage = parsePerPage();
        var maxPage = parseMaxPage();
        var taxonomies = parseTaxonomies();
        var custom_taxonomy = parseCustomTaxonomy();

        var data = {
            action: "get_blog_posts",
            post_type: filters,
            tags: tags,
            sort: sort,
            perpage: perPage,
            maxpage: maxPage,
            taxonomies: taxonomies,
            custom_taxonomy: custom_taxonomy
        };
        prepareParamsForUrl();
        doAjaxRequest(data)
        deleteQueryStringParameter('page_no');
    });

    jQuery(document).on('click', '.et_pb_searchsubmit', function (e) {
        if ($(this).hasClass('disabled'))
            return;

        submitForm();

    });

    jQuery(document).on('click', '.filter-search-form li', function (e) {

        if (jQuery(this).attr('data-filter') != 'all') {
            jQuery(document).find('.all-posts').removeClass('active');
            jQuery(this).toggleClass('active');
        } else {
            jQuery(document).find('.filter-search-form li').removeClass('active');
            jQuery(this).toggleClass('active');
        }

        var filters = parseFilters();

        var tags = parseTags();
        var sort = parseSort();
        var perPage = parsePerPage();
        var maxPage = parseMaxPage();

        var data = {
            action: "get_blog_posts",
            post_type: filters,
            tags: tags,
            sort: sort,
            perpage: perPage,
            maxpage: maxPage
        };

        prepareParamsForUrl();
        doAjaxRequest(data)
        deleteQueryStringParameter('page_no');

    });

    jQuery(document).on('click', '.taxonomy-search-form li', function (e) {

        if (jQuery(this).attr('data-filter') != 'all') {
            jQuery(document).find('.all-posts').removeClass('active');
            jQuery(this).toggleClass('active');
        } else {
            jQuery(document).find('.taxonomy-search-form li').removeClass('active');
            jQuery(this).toggleClass('active');
        }

        var filters = parseFilters();
        var taxonomies = parseTaxonomies();
        var custom_taxonomy = parseCustomTaxonomy();

        var tags = parseTags();
        var sort = parseSort();
        var perPage = parsePerPage();
        var maxPage = parseMaxPage();

        var data = {
            action: "get_blog_posts",
            post_type: filters,
            tags: tags,
            sort: sort,
            perpage: perPage,
            maxpage: maxPage,
            taxonomies: taxonomies,
            custom_taxonomy: custom_taxonomy
        };

        prepareParamsForUrl();
        doAjaxRequest(data)
        deleteQueryStringParameter('page_no');

    });

    function submitForm() {

        var filters = parseFilters();
        var tags = parseTags();
        var sort = parseSort();
        var perPage = parsePerPage();
        var maxPage = parseMaxPage();
        prepareParamsForUrl();
        var data = {
            action: "get_blog_posts",
            post_type: filters,
            tags: tags,
            sort: sort,
            perpage: perPage,
            maxpage: maxPage
        };

        doAjaxRequest(data)
        deleteQueryStringParameter('page_no');
    }

    function parsePerPage() {
        return jQuery(document).find('.per-page').val();
    }

    function parseMaxPage() {
        return jQuery(document).find('.max-page').val();
    }

    function doAjaxRequest(data) {

        jQuery(document).find('.blog_posts_shortcode').css('opacity', '0.5');
        jQuery.ajax({
            type: "POST",
            url: et_pb_custom.ajaxurl,
            data: data,
            success: function (msg) {
                var dataResp = JSON.parse(msg);
                var grid = document.querySelector('.et_pb_salvattore_content');
                jQuery(document).find('.et_pb_salvattore_content article').remove();

                jQuery(dataResp.output).find('article').each(function () {
                    var item = jQuery(this)[0];
                    salvattore.appendElements(grid, [item]);
                });
                jQuery(document).find('.blog_posts_shortcode').css('opacity', '1');
                jQuery(document).find('.load-more-btn').attr('data-page', 2);

                if (dataResp.maxPage === 1 || dataResp.maxPage === 0) {
                    jQuery(document).find('.load-more-btn').hide();
                } else {
                    jQuery(document).find('.load-more-btn').attr('data-max', dataResp.maxPage).show();
                }
                setCurrentItemsQty();
                setTotalItemsQty(dataResp.postQty);
                jQuery(".et_main_video_container").fitVids();

            }
        });

    }

    function parseSort() {
        const sort = jQuery(document).find('.sorting-select').val();

        if (sort) {
            return sort;
        } else {
            return 'desc';
        }
    }

    function parseTags() {
        const tags = jQuery('.tag-search-form li.active').map(function () {
            return jQuery(this).attr('data-tag');
        }).get().join(',');

        if (tags) {
            return tags;
        } else {
            return jQuery(document).find('.load-more-btn').attr('data-tags');
        }
    }

    // custom post types or categories
    function parseFilters() {
        const allFilter = jQuery(document).find('ul.filter-search-form .all-posts');

        if (allFilter.length === 0) {
            // Filters are disabled, try to get filters from load more btn
            return jQuery(document).find('.load-more-btn').attr('data-posttypes');
        }

        let check = jQuery('ul.filter-search-form li.active').map(function () {
            return jQuery(this).attr('data-filter');
        }).get().join(',');

        let checkTaxonomy = jQuery('ul.taxonomy-search-form li.active').map(function () {
            return jQuery(this).attr('data-filter');
        }).get().join(',');

        if (check.length === 0 && checkTaxonomy.length === 0) {
            allFilter.addClass('active');
        }
        if (allFilter.hasClass('active')) {
            return jQuery('ul.filter-search-form li:not(".all-posts")').map(function () {
                return jQuery(this).attr('data-filter');
            }).get().join(',');
        } else {
            return jQuery('ul.filter-search-form li.active').map(function () {
                return jQuery(this).attr('data-filter');
            }).get().join(',');
        }

    }

    function parseCustomTaxonomy() {
        return jQuery(document).find('.custom_taxonomy').val();
    }

    function parseTaxonomies() {
        const allFilter = jQuery(document).find('ul.taxonomy-search-form .all-posts');

        if (allFilter.length === 0) {
            // Filters are disabled, try to get filters from load more btn
            return jQuery(document).find('.load-more-btn').attr('data-taxonomies');
        }

        const check = jQuery('ul.filter-search-form li.active').map(function () {
            return jQuery(this).attr('data-filter');
        }).get().join(',');

        const checkTaxonomy = jQuery('ul.taxonomy-search-form li.active').map(function () {
            return jQuery(this).attr('data-filter');
        }).get().join(',');

        if (check.length === 0 && checkTaxonomy.length === 0) {
            allFilter.addClass('active');
        }
        if (allFilter.hasClass('active')) {
            return jQuery('ul.taxonomy-search-form li:not(".all-posts")').map(function () {
                return jQuery(this).attr('data-filter');
            }).get().join(',');
        } else {
            return jQuery('ul.taxonomy-search-form li.active').map(function () {
                return jQuery(this).attr('data-filter');
            }).get().join(',');
        }

    }

    function setCurrentItemsQty() {
        let currentItemsCount = jQuery(document).find('.et_pb_salvattore_content article').length;
        if (currentItemsCount) {
            jQuery(document).find('.current-items').text(currentItemsCount);
        } else {
            jQuery(document).find('.current-items').text(0);
        }
    }

    setCurrentItemsQty();

    function setTotalItemsQty(postsQty) {
        jQuery(document).find('.all-items').text(postsQty);
    }


    jQuery(document).on('click', '.load-more-btn', function (e) {
        e.preventDefault();
        var button = jQuery(this);
        var oldLabel = button.text();
        var currentItemsCountObject = jQuery(document).find('.current-items');
        var currentItemsCount = jQuery(document).find('.et_pb_salvattore_content article').length;
        let loadingMoreText = button.attr('data-loading_more_button_text');
        // console.log(loadingMoreText);

        button.text(loadingMoreText);
        var page = parseInt(jQuery(this).attr('data-page'));
        var nextPage = page + 1;
        setQueryStringParameter('page_no', page);
        if (page) {
            var grid = document.querySelector('.et_pb_salvattore_content');

            var filters = parseFilters();
            var tags = parseTags();
            var sort = parseSort();
            var perPage = parsePerPage();
            var taxonomies = parseTaxonomies();
            var custom_taxonomy = parseCustomTaxonomy();

            var data = {
                action: "get_blog_posts",
                post_type: filters,
                tags: tags,
                sort: sort,
                page: page,
                perpage: perPage,
                taxonomies: taxonomies,
                custom_taxonomy: custom_taxonomy
            };

            jQuery.ajax({
                type: "POST",
                url: et_pb_custom.ajaxurl,
                data: data,
                success: function (msg) {
                    var response = JSON.parse(msg);
                    var grid = document.querySelector('.et_pb_salvattore_content');
                    var articlesCount = 0;

                    jQuery(response.output).find('article').each(function () {
                        var item = jQuery(this)[0];
                        salvattore.appendElements(grid, [item]);
                        articlesCount += 1;
                    });

                    button.text(oldLabel);
                    button.attr('data-page', nextPage);

                    var maxPage = button.attr('data-max');

                    if (nextPage > maxPage) {
                        button.hide();
                    }

                    currentItemsCountObject.text(currentItemsCount + articlesCount)

                    jQuery(document).find('.blog_posts_shortcode').css('opacity', '1');
                    jQuery(".et_main_video_container").fitVids();
                }
            });
        }
    });

    jQuery(window).on('load', function () {
        checkTags();
    });


    function checkTags() {
        const allTags = jQuery(document).find('.tag-search-form li').length;
        const selectedTags = jQuery(document).find('.tag-search-form li.active').length;
        const unselectedTags = allTags - selectedTags;


        if (allTags === selectedTags) {
            jQuery(document).find('.select-all').addClass('disabled');
        } else {
            jQuery(document).find('.select-all').removeClass('disabled');
        }

        if (allTags === unselectedTags) {
            jQuery(document).find('.deselect-all').addClass('disabled');
            jQuery(document).find('.et_pb_searchsubmit').addClass('disabled');
        } else {
            jQuery(document).find('.deselect-all').removeClass('disabled');
            jQuery(document).find('.et_pb_searchsubmit').removeClass('disabled');
        }

    }

    jQuery(document).on('click', '.select-all', function (e) {
        e.preventDefault;

        if (jQuery(this).hasClass('disabled')) return false;

        activateAllTags();
        checkTags();
        submitForm();
    });

    jQuery(document).on('click', '.deselect-all', function (e) {
        e.preventDefault;

        if (jQuery(this).hasClass('disabled')) return false;

        deactivateAllTags()
        checkTags();
        submitForm();
    });

    jQuery(document).on('click', '.row-title', function (e) {
        deactivateAllTags();
        activateAllTagsInRow(jQuery(this).parent());
        checkTags();
        submitForm();
    });

    function checkIsNewRow(row) {
        // const selected = jQuery(document).find('.tag-search-form li.active').parent().attr('data-row-no');
        const selected = jQuery(document).find('.tag-search-form li.active').parent().attr('data-row-no');
        // console.log()
        return row.attr("data-row-no") !== selected;
    }

    function isAllTagsAreSelected() {
        return jQuery(document).find('.tag-search-form li').length === jQuery(document).find('.tag-search-form li.active').length;
    }

    function deactivateAllTags() {
        jQuery(document).find('.tag-search-form li').removeClass('active');
    }

    function activateAllTags() {
        jQuery(document).find('.tag-search-form li').addClass('active');
    }

    function activateAllTagsInRow(row) {
        row.find('li').addClass('active');
    }
});



